import {queryClient} from '~/lib/queryClient';
import {DSP_CONNECTION_TYPES_QUERY_KEY} from '~/modules/Dictionary/queries';
import {IDspConnectionType} from '~/modules/Dictionary/models/DspConnectionType';

const getDspConnectionTypeLabel = (payer: string): string | null => {
    const dspConnectionTypes = queryClient.getQueryData(DSP_CONNECTION_TYPES_QUERY_KEY) as IDspConnectionType[] | undefined;
    if (!Array.isArray(dspConnectionTypes) || dspConnectionTypes.length === 0) {
        return null;
    }

    const normalized = payer.toLowerCase();
    const matched = dspConnectionTypes.find((item) => item?.name && item.name.toLowerCase() === normalized);
    return matched?.label || null;
};

export const getPayerLabel = (payer?: string | null): string => {
    if (!payer) {
        return '';
    }

    const labelFromDictionary = getDspConnectionTypeLabel(payer);
    if (labelFromDictionary) {
        return labelFromDictionary;
    }

    return payer;
};
